/* jshint undef: true, unused: true, indent: 4, jquery: true */
/* global document, window */

if (typeof showExit == 'undefined') {
    var showExit = 1;
}

var onLeaveOpen = function() {
    window.scrollTo(0,0);
    $('#onleave-offer').show();
    togglePop(0);
};

var togglePop = function(toggle) {
    showExit = toggle;
};

var dontLeaveUs = function() {
    if (showExit == 1) {
        $('#page').hide();

        // bPopup assigns a pixel-specific screen location with position:absolute.
        // The leftPosition variable below presumes an image width of 640 pixels (320 represents half that width)
        var leftPosition = (document.documentElement.clientWidth / 2) - 320;
        if (leftPosition < 0) {
            leftPosition = 0;
        }
        var onLeavePopPosition = [leftPosition, 100];

        if ($('html').hasClass('touch')) {
            onLeavePopPosition = [0, 100];
        }

        $('#onleave-wrapper').css({display : ''});
        $('#onleave-offer').bPopup({
            appendTo: '#onleave-wrapper',
            position: onLeavePopPosition,
            escClose: false,
            follow: [false, false],
            modalClose: false,
            opacity: 9.0,
            onOpen: onLeaveOpen
        });

        return "WAIT!  You could be missing out on a great deal!";

    } else {
        return;
    }
};

$(document).ready(function() {

    $('footer a').click(function(e){
        e.preventDefault();
        e.stopImmediatePropagation();
        var day = new Date();
        var id = day.getTime();
        window.open($(this).attr('href'), id, 'toolbar=0,scrollbars=1,location=0,statusbar=0,menubar=0,resizable=0,width=400,height=300,left = 500,top = 500');
        return false;
    });

    $('#main-form').validationEngine({'showOneMessage' : true, 'promptPosition' : 'topLeft'});

    $('#main-form').submit(function(){
        togglePop(0);

        if (!$('#main-form').validationEngine('validate')) {
            togglePop(1);
            return false;
        }
    });


    if (typeof $('#onleave-offer') !== 'undefined' && $('#onleave-offer').length > 0) {
        window.onbeforeunload = dontLeaveUs;
    }

    $(window).on("message", function(e) {
        try {
            var eventData = JSON.parse(e.originalEvent.data);
            if (eventData.isLast !== 'undefined' && eventData.isLast === 'true') {
                togglePop(0);
            }
        } catch(e) {
            /* do nothing on purpose */
        }
    });

    // Adding click handler to show proper step
    $('.step-click').click(function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var matchedStepId  = $(this).attr('id') + '-data';
        $('.step-data').each(function(idx, a) {
            var el = $(a);
            if (el.attr('id') == matchedStepId) {
                el.show();
            } else {
                el.hide();
            }
        });
        // remove current class from LI element
        $('#sub-nav ol').children().removeClass('current');
        // Add current to currently clicked item
        $(this).parent().addClass('current');
    });
});
